import { render } from "./ReviewsModal.vue?vue&type=template&id=f41062e8&scoped=true"
import script from "./ReviewsModal.vue?vue&type=script&lang=js"
export * from "./ReviewsModal.vue?vue&type=script&lang=js"

import "../../../../reports/css/modal.css?vue&type=style&index=0&id=f41062e8&scoped=true&lang=css"

import exportComponent from "/home/forge/staging.hikeseo.co/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f41062e8"]])

export default __exports__